import { createIntl, createIntlCache } from 'react-intl';

import { getLocale } from './locale.helper';
import messages from './messages';

const cache = createIntlCache();
const locale = getLocale();

const localeMessages = messages[`${locale}`] || {};

const intl = createIntl({ locale, messages: localeMessages }, cache);

// utility function to translate in non-React files
const translate = (id, values = {}) => intl.formatMessage({ id }, values);

export default translate;
